import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
  // hash 哈希模式带#号  不会出现 history 模式找不到文件的问题
  mode: 'hash',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'index',
      meta: { index: 0 }, // meta对象的index用来定义当前路由的层级,由小到大,由低到高
      // component: resolve => require(['../views/base/base.vue'], resolve)
      component: () => import('@/views/index.vue')
    },
    {
      path: '/elsword',
      name: 'elsword',
      meta: { index: 0 }, // meta对象的index用来定义当前路由的层级,由小到大,由低到高
      // component: resolve => require(['../views/base/base.vue'], resolve)
      component: () => import('@/views/index.vue')
    },
    {
      path: '/rena',
      name: 'rena',
      meta: { index: 1 },
      component: () => import('@/views/rena.vue')
    },
    {
      path: '/chung',
      name: 'chung',
      meta: { index: 2 },
      component: () => import('@/views/chung.vue')
    },
    {
      path: '/ara',
      name: 'ara',
      meta: { index: 3 },
      component: () => import('@/views/ara.vue')
    },
    {
      path: '/elesis',
      name: 'elesis',
      meta: { index: 4 },
      component: () => import('@/views/elesis.vue')
    },
    {
      path: '/ain',
      name: 'ain',
      meta: { index: 5 },
      component: () => import('@/views/ain.vue')
    },
    {
      path: '/laby',
      name: 'laby',
      meta: { index: 6 },
      component: () => import('@/views/laby.vue')
    },
    {
      path: '/aisha',
      name: 'aisha',
      meta: { index: 7 },
      component: () => import('@/views/aisha.vue')
    },
    {
      path: '/raven',
      name: 'raven',
      meta: { index: 8 },
      component: () => import('@/views/raven.vue')
    },
    {
      path: '/eve',
      name: 'eve',
      meta: { index: 9 },
      component: () => import('@/views/eve.vue')
    },
    {
      path: '/add',
      name: 'add',
      meta: { index: 10 },
      component: () => import('@/views/add.vue')
    },
    {
      path: '/lu',
      name: 'lu',
      meta: { index: 11 },
      component: () => import('@/views/lu.vue')
    },
    {
      path: '/ciel',
      name: 'ciel',
      meta: { index: 12 },
      component: () => import('@/views/ciel.vue')
    },
    {
      path: '/rose',
      name: 'rose',
      meta: { index: 13 },
      component: () => import('@/views/rose.vue')
    }

  ]
});

/**
 * 每次路由跳转是判断，是否解析了 微信配置需要参数
 * 若未获取则获取一次
 */
// router.beforeEach((to, from, next) => {
//   // console.log(to, from, next);

//   // if (!store.state.bIsGetWxConfig){
//   //   store.dispatch(types.GET_WX_CONFIG, {});
//   // }
//   next();
// });
// router.afterEach((to, from) => {
//   console.log(to, from)
//   // console.log(to, from, 'after');
//   // if (Object.keys(from.query).length){
//   //   let {openid,sceneId} = from.query;
//   //   to.query = { openid, sceneId}
//   // }
// })

export default router;
